import React, { Component, Fragment } from "react";
import { Alert } from "reactstrap";
import Validation from "./Validation";
import style from "./Precheck.module.scss";
import Authorization from "./Authorization";
import { IOMode, IOType } from "../../../IO/types";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import { formatIOforUpdate } from "../../../IO/utils";
import { Mode } from "../../../../utils";

class Precheck extends React.PureComponent {
  state = {
    validations: null,
    status: null,
    waitingCounter: null,
  };

  componentDidMount() {
    this._isMounted = true;
    const { io, services } = this.props;

    services.fetchRiskvalidations({ process: getProcess(io.IOType, io.IOMode) }).then((resp) => {
      if (this._isMounted) {
        this.setState({
          validations: resp.response.validations.reduce((obj, v) => {
            obj[v.ValidationProgram] = v;
            return obj;
          }, {}),
        });
        this.validateRules();
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  validateRules = () => {
    const { validations } = this.state;
    const { services } = this.props;

    this.setState({ waitingCounter: Object.keys(validations).length });

    Object.values(validations).forEach((validation) => {
      const service = validation.ValidationProgram;
      const { actions, io } = this.props;

      services
        .fetchValidationsCheckRule({
          service,
          io: formatIOforUpdate(io),
          validation,
        })
        .then((resp) => {
          const { result } = resp.response.validation;
          const { history } = resp.response;

          let status = "success";
          let title;

          if (result.Code !== 200) {
            if (validation.OverrridableByAuthorization !== "0") {
              title = result.Description != "" ? result.Description : null;
              this.checkIfCanBeAuthorized(validation, title);
              return;
            } else {
              status = "failed";
              title = result.Description != "" ? result.Description : null;
            }
          }

          this.updateValidationStatus(
            {
              ...validation,
              history,
            },
            status,
            title
          );
        });
    });
  };

  updateValidationStatus = (validation, vStatus, title) => {
    const { validations, waitingCounter, status } = this.state;
    const { dispatch } = this.props;

    let globalStatus = status == "failed" ? status : vStatus;

    // Si fue la ultima validacion y no fallo
    if (globalStatus != "failed" && waitingCounter == 1) {
      globalStatus = "completed";
    }

    const _validations = {
      ...validations,
      [validation.ValidationProgram]: {
        ...validations[validation.ValidationProgram],
        status: vStatus,
        history: validation.history,
        title,
      },
    };

    if (waitingCounter == 1) {
      dispatch({
        type: "UPDATE_PRECHECK",
        fields: {
          histories: Object.values(_validations)
            .filter((v) => v.history != undefined)
            .map((v) => v.history),

          validations: _validations,
          status: globalStatus,
        },
      });

      dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
    }
    this._isMounted &&
      this.setState({
        validations: _validations,
        status: globalStatus,
        waitingCounter: waitingCounter - 1,
      });
  };

  checkIfCanBeAuthorized = (validation, title) => {
    const { dispatch, io } = this.props;
    const { services } = this.props;

    const authorizationdefinitionid = validation.OverrridableByAuthorization;
    const authorizationDesc = title;
    services
      .fetchAuthorizeCheckIO({
        authorizationdefinitionid,
        io: formatIOforUpdate(io),
        authorizationDescription: authorizationDesc,
      })
      .then((resp) => {
        const authorization = resp.authorizationsdt;
        const { precheck } = this.props;

        let status = "failed";

        if (authorization.canbeauthorized) {
          status = "authorization";

          dispatch({
            type: "UPDATE_PRECHECK",
            fields: {
              authorizations: [
                ...precheck.authorizations,
                { name: validation.ValidationName, ...authorization },
              ],
            },
          });
        }

        this.updateValidationStatus(validation, status, title);
      });
  };

  updateAuthorizationMessage = (name, text) => {
    const { dispatch, precheck } = this.props;

    const authorizations = precheck.authorizations.map((auth) => {
      if (auth.name === name) {
        return {
          ...auth,
          text,
          error: undefined,
          readonly: undefined,
        };
      }
      return auth;
    });

    dispatch({ type: "UPDATE_PRECHECK", fields: { authorizations } });
  };

  render() {
    const { precheck } = this.props;
    const { validations, status, waitingCounter } = this.state;

    return (
      <div className={style.precheck}>
        {validations == null ? (
          <LoadingMessage text="Retrieving risk validations" />
        ) : (
          <div className={style.validations}>
            <p className="h6">Validations</p>
            {Object.values(validations).map((v, index) => (
              <Validation validation={v} key={`val-${index}`} />
            ))}
          </div>
        )}

        {status != null ? (
          status == "failed" ? (
            <NoPassConditions />
          ) : (
            precheck.authorizations.length > 0 &&
            waitingCounter == 0 && (
              <Fragment>
                <p className="h6">Authorizations</p>
                <div className={style.authorizations}>
                  {precheck.authorizations.map((a, index) => (
                    <Authorization
                      authorization={a}
                      changeMessage={this.updateAuthorizationMessage}
                      key={`auth-${index}`}
                    />
                  ))}
                </div>
              </Fragment>
            )
          )
        ) : null}
      </div>
    );
  }
}

const getProcess = (type, mode) => {
  switch (type) {
    case IOType.Deposit:
      if (mode == IOMode.MultipleAssets) {
        return "BulkDeposit";
      }
      return "Deposit";

    case IOType.Withdraw:
      if (mode == IOMode.MultipleAssets) {
        return "BulkWidhdraw";
      } else {
        return "Withdraw";
      }
    case IOType.Transfer:
      return "Transfer";
  }
};

const NoPassConditions = () => (
  <Fragment>
    <hr />
    <Alert color="danger" className={style.alert}>
      IO declined by system.
    </Alert>
  </Fragment>
);

export const LoadingMessage = ({ text, ...props }) => (
  <div className={style.loadingMessage} style={props.style || {}}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export default Precheck;
